// extracted by mini-css-extract-plugin
export default {"cell":"Cell-module_cell__lB9Yb","center":"Cell-module_center__gnWY_","right":"Cell-module_right__f30Br"};